import * as React from "react";
import { Panel } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import * as actions from "../../../actions";
import { FlexLayout, IconBar, Spinner, ToolbarIcon, } from "../../../controls/api";
import * as util from "../../../util/api";
import { ComponentEx } from "../../../controls/ComponentEx";
import * as selectors from "../../../util/selectors";
import { DNDContainer, MainPage } from "../../../views/api";
import { setGameLoadOrderRendererOptions } from "../actions/settings";
import DraggableList from "./DraggableList";
import DefaultInfoPanel from "./DefaultInfoPanel";
import DefaultItemRenderer from "./DefaultItemRenderer";
const PanelX = Panel;
const NAMESPACE = "generic-load-order-extension";
class LoadOrderPage extends ComponentEx {
    mCallbackDebouncer;
    mUpdateDebouncer;
    mForceUpdateDebouncer;
    mStaticButtons;
    constructor(props) {
        super(props);
        this.initState({
            enabled: [],
            sortType: "ascending",
            loading: true,
            updating: false,
            itemRenderer: undefined,
            i18nNamespace: undefined,
        });
        this.mUpdateDebouncer = new util.Debouncer(() => {
            const { enabled } = this.state;
            const updateType = "refresh";
            this.setLoadOrder(enabled, updateType);
            this.mCallbackDebouncer.schedule(undefined, updateType);
            this.nextState.updating = false;
            return null;
        }, 500);
        this.mCallbackDebouncer = new util.Debouncer((updateType) => {
            const { loadOrder, profile, getGameEntry } = this.props;
            if (profile === undefined) {
                return null;
            }
            const activeGameEntry = getGameEntry(profile.gameId);
            if (!!activeGameEntry.callback) {
                activeGameEntry.callback(loadOrder, updateType);
            }
            return null;
        }, 500);
        this.mForceUpdateDebouncer = new util.Debouncer(() => {
            this.nextState.updating = true;
            this.updateState(this.props, true, "refresh");
            return null;
        }, 200, false, true);
        this.mStaticButtons = [
            {
                component: ToolbarIcon,
                props: () => {
                    return {
                        id: "btn-deploy",
                        key: "btn-deploy",
                        icon: "deploy",
                        text: "Deploy Mods",
                        className: this.props.needToDeploy
                            ? "toolbar-flash-button"
                            : undefined,
                        onClick: () => this.context.api.events.emit("deploy-mods", () => undefined),
                    };
                },
            },
            {
                component: ToolbarIcon,
                props: () => {
                    return {
                        id: "btn-sort-direction",
                        key: "btn-sort-direction",
                        icon: this.state.sortType === "ascending" ? "sort-down" : "sort-up",
                        text: this.state.sortType === "ascending"
                            ? "Sort Descending"
                            : "Sort Ascending",
                        className: "load-order-sort-direction",
                        onClick: () => {
                            this.nextState.sortType =
                                this.state.sortType === "ascending"
                                    ? "descending"
                                    : "ascending";
                            this.mForceUpdateDebouncer.schedule();
                        },
                    };
                },
            },
            {
                component: ToolbarIcon,
                props: () => {
                    return {
                        id: "btn-select-list-view",
                        key: "btn-select-list-view",
                        icon: "layout-list",
                        text: this.props.itemRendererOptions.listViewType === "full"
                            ? "Compact View"
                            : "Full View",
                        className: "load-order-list-view",
                        onClick: this.onChangeViewType,
                    };
                },
                condition: () => {
                    return this.state.itemRenderer === DefaultItemRenderer;
                },
            },
            {
                component: ToolbarIcon,
                props: () => {
                    return {
                        id: "btn-refresh-list",
                        key: "btn-refresh-list",
                        icon: this.state.updating ? "spinner" : "refresh",
                        text: "Refresh List",
                        className: "load-order-refresh-list",
                        onClick: this.onRefreshList,
                    };
                },
            },
        ];
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        if (this.state.updating === true) {
            return;
        }
        if (this.stringified(this.props.loadOrder) !==
            this.stringified(newProps.loadOrder) ||
            this.stringified(this.props.mods) !== this.stringified(newProps.mods) ||
            this.stringified(this.props.profile) !==
                this.stringified(newProps.profile)) {
            const updateLO = this.props.profile === newProps.profile &&
                this.stringified(this.props.loadOrder) !==
                    this.stringified(newProps.loadOrder);
            this.updateState(newProps, updateLO);
        }
    }
    componentDidMount() {
        const renderer = this.getItemRenderer();
        if (renderer !== this.state.itemRenderer) {
            this.nextState.itemRenderer = renderer;
        }
        this.updateState(this.props);
        this.nextState.loading = false;
    }
    componentWillUnmount() {
        this.resetState();
    }
    render() {
        const { loading } = this.state;
        return loading ? this.renderWait() : this.renderLoadOrderPage();
    }
    stringified(obj) {
        return !!obj ? JSON.stringify(obj) : obj;
    }
    resetState() {
        this.nextState.loading = true;
        this.nextState.updating = false;
        this.nextState.itemRenderer = undefined;
        this.nextState.i18nNamespace = undefined;
        this.nextState.enabled = [];
    }
    setLoadOrder(list, update) {
        this.nextState.updating = true;
        const { loadOrder, onSetOrder, profile, getGameEntry } = this.props;
        const loKeys = Object.keys(loadOrder);
        const hasLOEntry = (modId) => loKeys.includes(modId);
        const setNewOrder = (newList) => {
            const locked = loKeys.filter((key) => !!loadOrder[key]?.locked);
            const newOrder = newList.reduce((accum, entry, idx) => {
                if (loKeys.length === 0) {
                    // First run
                    accum[entry.id] = {
                        pos: idx,
                        enabled: true,
                        locked: false,
                        prefix: entry.prefix,
                        data: entry.data,
                    };
                    return accum;
                }
                if (locked.includes(entry.id)) {
                    accum[entry.id] = {
                        pos: loadOrder[entry.id].pos,
                        enabled: loadOrder[entry.id].enabled,
                        locked: true,
                        prefix: entry.prefix,
                        data: entry.data,
                    };
                }
                else {
                    const existing = Object.keys(accum);
                    const wantedPos = idx;
                    const posTaken = existing.find((key) => accum[key].pos === wantedPos) !== undefined;
                    if (posTaken) {
                        const sorted = existing.sort((a, b) => accum[a].pos - accum[b].pos);
                        let previousPos = 0;
                        for (const element of sorted) {
                            if (accum[element].pos !== previousPos + 1) {
                                accum[entry.id] = {
                                    pos: previousPos + 1,
                                    enabled: hasLOEntry(entry.id)
                                        ? loadOrder[entry.id].enabled
                                        : true,
                                    locked: false,
                                    prefix: entry.prefix,
                                    data: entry.data,
                                };
                                return accum;
                            }
                            previousPos = accum[element].pos;
                        }
                        accum[entry.id] = {
                            pos: previousPos + 1,
                            enabled: hasLOEntry(entry.id)
                                ? loadOrder[entry.id].enabled
                                : true,
                            locked: false,
                            prefix: entry.prefix,
                            data: entry.data,
                        };
                    }
                    else {
                        accum[entry.id] = {
                            pos: wantedPos,
                            enabled: hasLOEntry(entry.id)
                                ? loadOrder[entry.id].enabled
                                : true,
                            locked: false,
                            prefix: entry.prefix,
                            data: entry.data,
                        };
                    }
                }
                return accum;
            }, {});
            const sortedList = newList.sort((a, b) => newOrder[a.id].pos - newOrder[b.id].pos);
            if (JSON.stringify(sortedList) !== JSON.stringify(this.state.enabled)) {
                // Just in case the component's state is out of sync for some
                //  reason - this will trigger a re-render unfortunately.
                this.nextState.enabled = sortedList;
            }
            if (JSON.stringify(newOrder) === JSON.stringify(loadOrder)) {
                // Nothing changed, go home load order page, you're drunk.
                return;
            }
            onSetOrder(profile.id, newOrder);
        };
        const activeGameEntry = getGameEntry(profile.gameId);
        if (!!activeGameEntry.preSort) {
            activeGameEntry
                .preSort(list, this.state.sortType, update)
                .then((newList) => !!newList ? setNewOrder(newList) : setNewOrder(list));
        }
        else {
            setNewOrder(list);
        }
    }
    // If the itemRenderer hasn't been assigned yet or is different than the
    //  one that the game extension provided - assign the default item renderer.
    getItemRenderer() {
        const { getGameEntry, profile, onSetLoadOrderRendererOptions, itemRendererOptions, } = this.props;
        const { itemRenderer } = this.state;
        if (profile === undefined) {
            return undefined;
        }
        const useDefault = (gameEntry) => {
            onSetLoadOrderRendererOptions(profile.gameId, {
                displayCheckboxes: gameEntry?.displayCheckboxes === false ? false : true,
                listViewType: !!itemRendererOptions?.listViewType
                    ? itemRendererOptions.listViewType
                    : "full",
            });
            return DefaultItemRenderer;
        };
        const activeGameEntry = getGameEntry(profile.gameId);
        if (activeGameEntry === undefined) {
            // There's no game entry for this game; that's expected for games
            //  which do not use the LO page.
            return undefined;
        }
        if (itemRenderer === undefined &&
            activeGameEntry.itemRenderer === undefined) {
            return useDefault(activeGameEntry);
        }
        return !!activeGameEntry.itemRenderer
            ? activeGameEntry.itemRenderer
            : useDefault(activeGameEntry);
    }
    renderLoadOrderPage() {
        const { t, getGameEntry, profile, loadOrder } = this.props;
        const { enabled, itemRenderer } = this.state;
        const enabledIds = enabled.map((mod) => mod.id);
        const loadOrderIds = Object.keys(loadOrder);
        const difference = enabledIds.filter((x) => loadOrderIds.find((mod) => mod === x) === undefined);
        if (difference.length !== 0) {
            this.mUpdateDebouncer.schedule();
            return null;
        }
        const activeGameEntry = profile !== undefined ? getGameEntry(profile.gameId) : undefined;
        if (activeGameEntry === undefined) {
            return null;
        }
        const res = activeGameEntry.createInfoPanel({
            refresh: () => this.mForceUpdateDebouncer.schedule(),
        });
        const infoPanel = typeof res === "string" ? React.createElement(DefaultInfoPanel, { infoText: res }) : res;
        const sorted = this.state.sortType === "ascending"
            ? enabled.sort((lhs, rhs) => loadOrder[lhs.id].pos - loadOrder[rhs.id].pos)
            : enabled.sort((lhs, rhs) => loadOrder[rhs.id].pos - loadOrder[lhs.id].pos);
        return !!sorted ? (React.createElement(MainPage, null,
            React.createElement(MainPage.Header, null,
                React.createElement(IconBar, { group: "generic-load-order-icons", staticElements: this.mStaticButtons, className: "menubar", t: t })),
            React.createElement(MainPage.Body, null,
                React.createElement(Panel, null,
                    React.createElement(PanelX.Body, null,
                        React.createElement(DNDContainer, { style: { height: "100%" } },
                            React.createElement(FlexLayout, { type: "row" },
                                React.createElement(FlexLayout.Flex, null,
                                    React.createElement(DraggableList, { id: "mod-loadorder-draggable-list", itemRenderer: itemRenderer, loadOrder: loadOrder, items: sorted, apply: this.onApply })),
                                React.createElement(FlexLayout.Flex, null, infoPanel)))))))) : null;
    }
    onApply = (ordered) => {
        const updateType = "drag-n-drop";
        this.setLoadOrder(ordered, updateType);
        this.mCallbackDebouncer.schedule(undefined, updateType);
        this.nextState.updating = false;
    };
    onChangeViewType = () => {
        const { onSetLoadOrderRendererOptions, profile, itemRendererOptions } = this.props;
        const newOpts = {
            displayCheckboxes: itemRendererOptions.displayCheckboxes,
            listViewType: itemRendererOptions.listViewType === "full" ? "compact" : "full",
        };
        onSetLoadOrderRendererOptions(profile.gameId, newOpts);
    };
    onRefreshList = () => {
        this.mForceUpdateDebouncer.schedule();
    };
    renderWait() {
        return (React.createElement(Spinner, { style: {
                width: "64px",
                height: "64px",
            } }));
    }
    updateState(props, updateLO = false, updateType = null) {
        const { getGameEntry, mods, profile } = props;
        const activeGameEntry = getGameEntry(profile.gameId);
        if (activeGameEntry === undefined) {
            // User may have switched to a game which does not use
            //  the generic load order extension. In this case we just
            //  return.
            return;
        }
        const mapToDisplay = (mod) => ({
            id: mod.id,
            name: mod?.attributes !== undefined ? util.renderModName(mod) : mod.id,
            imgUrl: !!mod?.attributes?.pictureUrl
                ? mod.attributes.pictureUrl
                : activeGameEntry.gameArtURL,
        });
        const modState = Object.keys(mods).filter((mod) => util.getSafe(profile, ["modState", mod, "enabled"], false));
        const filtered = !!activeGameEntry.filter
            ? activeGameEntry
                .filter(modState.map((id) => mods[id]))
                .map((mod) => mapToDisplay(mod))
            : modState.map((mod) => mapToDisplay(mods[mod]));
        const en = this.state.enabled.filter((mod) => filtered.find((entry) => entry.id === mod.id) !== undefined);
        const difference = filtered.filter((x) => en.find((mod) => mod.id === x.id) === undefined);
        const spread = [...en, ...difference];
        updateType = updateType !== null ? updateType : "props-update";
        const update = (newDisplayItems) => {
            if (updateLO ||
                this.stringified(spread) !== this.stringified(newDisplayItems)) {
                this.setLoadOrder(newDisplayItems, updateType);
                this.mCallbackDebouncer.schedule(undefined, updateType);
                this.nextState.updating = false;
            }
        };
        if (!!activeGameEntry.preSort) {
            activeGameEntry
                .preSort(spread, this.state.sortType, updateType)
                .then((newList) => {
                const wantedList = !!newList ? newList : spread;
                this.nextState.enabled = wantedList;
                update(wantedList);
            });
        }
        else {
            this.nextState.enabled = spread;
            update(spread);
        }
    }
}
const empty = {};
const defaultOpts = {
    listViewType: "full",
    displayCheckboxes: true,
};
function mapStateToProps(state, ownProps) {
    const profile = selectors.activeProfile(state) || undefined;
    let loadOrder = {};
    let itemRendererOptions = defaultOpts;
    if (!!profile?.gameId) {
        loadOrder = util.getSafe(state, ["persistent", "loadOrder", profile.id], empty);
        itemRendererOptions = util.getSafe(state, ["settings", "loadOrder", "rendererOptions", profile.gameId], defaultOpts);
    }
    return {
        itemRendererOptions,
        loadOrder,
        mods: util.getSafe(state, ["persistent", "mods", profile.gameId], []),
        profile,
        needToDeploy: selectors.needToDeploy(state),
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onSetLoadOrderRendererOptions: (gameId, options) => dispatch(setGameLoadOrderRendererOptions(gameId, options)),
        onSetDeploymentNecessary: (gameId, necessary) => dispatch(actions.setDeploymentNecessary(gameId, necessary)),
        onSetOrder: (profileId, loadOrder) => {
            dispatch(actions.setLoadOrder(profileId, loadOrder));
        },
    };
}
export default withTranslation(["common", NAMESPACE])(connect(mapStateToProps, mapDispatchToProps)(LoadOrderPage));
